module.exports = __webpack_public_path__ + "static/media/PublishIcon.183c443b.svg";